// extracted by mini-css-extract-plugin
module.exports = {"mainCarousel":"QuickPreviewModal_mainCarousel__LHWXr","thumbnailSlide":"QuickPreviewModal_thumbnailSlide__rkJAL"};